import { styled } from 'linaria/react';
import { media } from '../../../../../media';

export const MainSection = styled.section`
	width: 100%;
	padding-top: 25px;

	&::after {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		display: none;
		width: 100%;
		background-color: #d6d2cf;
		content: '';
	}

	${media.tablet} {
		position: relative;
		padding-top: 25px;
		background-color: #f2f3f5;

		&::after {
			display: block;
			height: 322px;
		}
	}

	${media.mobile} {
		&::after {
			height: 240px;
		}
	}
`;
